import { Group, Scene, Vector3, Euler } from 'three';
import { AircraftPhysics } from './AircraftPhysics';
import { InputManager } from '../utils/InputManager';
import { AircraftData } from '../data/aircraft';
import { buildStealthModel } from './StealthFighter';
import { buildGen4Model } from './Gen4Fighter';
import { buildMarineModel } from './MarineFighter';

// re-export for backward compatibility (GameFlow等が使用)
export { buildStealthModel } from './StealthFighter';

export class PlayerAircraft {
  readonly group: Group;
  readonly physics: AircraftPhysics;
  private input: InputManager;

  constructor(scene: Scene, input: InputManager, aircraftData?: AircraftData) {
    this.input = input;
    this.physics = new AircraftPhysics(aircraftData?.physics);

    if (aircraftData?.id === 'gen4') {
      this.group = buildGen4Model();
    } else if (aircraftData?.id === 'marine') {
      this.group = buildMarineModel();
    } else {
      this.group = buildStealthModel();
    }
    this.group.position.set(3500, 500, 3000);
    scene.add(this.group);
  }

  update(delta: number, groundHeight: number): void {
    const { dx, dy } = this.input.consumeMouse();

    const accel = this.input.isDown('KeyW');
    const decel = this.input.isDown('KeyS');
    const boost = this.input.isDown('ShiftLeft') || this.input.isDown('ShiftRight');

    const locked = this.input.isPointerLocked();
    this.physics.update(delta, locked ? dx : 0, locked ? dy : 0, accel, decel, boost);

    const vel = this.physics.getVelocity();
    this.group.position.addScaledVector(vel, delta);

    const minY = groundHeight + 30;
    if (this.group.position.y < minY) {
      this.group.position.y = minY;
      if (this.physics.pitch > 0) this.physics.pitch *= 0.5;
    }

    if (this.group.position.y > 10000) {
      this.group.position.y = 10000;
      if (this.physics.pitch < 0) this.physics.pitch = 0;
    }

    const BOUND = 9500;
    this.group.position.x = Math.max(-BOUND, Math.min(BOUND, this.group.position.x));
    this.group.position.z = Math.max(-BOUND, Math.min(BOUND, this.group.position.z));

    this.group.rotation.set(this.physics.pitch, this.physics.yaw, this.physics.roll, 'YXZ');
  }

  get position(): Vector3 { return this.group.position; }
  get rotation(): Euler  { return this.group.rotation; }
  get speedKmh(): number { return this.physics.speedKmh; }
  get altitudeM(): number { return Math.round(this.group.position.y); }
}
